/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Box from '@mui/material/Box';
import * as styles from './Klarna.style';
export const KlarnaPanel = ({ name, simulationUrl, helpUrl, cardTypeCode = 0, }) => {
    return (jsx(Box, null,
        jsx(Box, { "data-qa": `klarna-panel ${cardTypeCode} `, sx: styles.klarnaPanelContainer },
            jsx("iframe", { css: styles.klarnaPanel, title: name, src: simulationUrl }),
            jsx("img", { css: styles.trackingImage, src: helpUrl }))));
};
